import gsap from 'gsap'
import { Flip } from 'gsap/Flip'
import { lenis } from './lenis'
import barba from '@barba/core'

gsap.registerPlugin(Flip)

export class AnimationBanner {
  constructor(el) {
    this.el = el

    lenis.stop()

    document.fonts.ready.then(() => {
      this.pinBanner()
      this.initialAnimation()
      this.wordTicker()
      this.scrollArrow()
    })
  }
  initialAnimation() {
    const words = this.el.querySelectorAll('.word')
    const imageHolders = this.el.querySelectorAll('.banner__image-holder, .banner__video-holder')
    const mobileVideoHolder = this.el.querySelector('.banner__mobile-video-holder')
    const hasPreloader = Alpine.store('hasPreloader').check

    const tl = gsap.timeline({
      paused: true,
      onComplete: () => {
        this.expandVideo()
        lenis.start()
      }
    })

    if (hasPreloader) {
      Alpine.effect(() => {
        const preloader = Alpine.store('hasPreloader').check
        if (!preloader) tl.play()
      })
    } else {
      setTimeout(() => {
        tl.play()
      }, 100)
    }

    tl.to(words, {
      y: 0,
      duration: 2.75,
      stagger: 0.06,
      ease: 'expo.inOut'
    })

    tl.to(
      imageHolders,
      {
        scale: 1,
        margin: 0,
        width: window.innerWidth <= 650 ? '11.2820512821vw' : '13.0208333333vw',
        duration: 1,
        ease: 'power2.inOut'
      },
      '-=1'
    )

    tl.to(
      mobileVideoHolder,
      {
        duration: 1.8,
        clipPath: 'inset(0% 0 0 0)',
        ease: 'expo.inOut'
      },
      1.4
    )
  }
  pinBanner() {
    const pin = this.el.querySelector('.banner__pin')

    if (window.innerWidth <= 1024) return

    this.pinTl = gsap.timeline({
      scrollTrigger: {
        trigger: pin,
        pin: true,
        start: 'top top',
        end: '+=1000'
      }
    })
  }
  expandVideo() {
    if (window.innerWidth <= 1024) return

    const state = Flip.getState('.banner__video-holder, .banner__video-target')
    // const spacer = this.el.querySelector('.banner__text-spacer')
    // const spacer = document.createElement('div').classList.add('banner__text-spacer')
    const spacer = document.createElement('div')
    const video = this.el.querySelector('.banner__video-holder')
    const words = this.el.querySelectorAll('.line:nth-child(3) .word')
    const heading = this.el.querySelector('.banner__heading')
    const images = this.el.querySelectorAll('.banner__image-holder')
    const container = this.el.querySelector('.container')

    Flip.to(state, {
      simple: true,
      absolute: true,
      scrollTrigger: {
        trigger: this.el,
        start: 'top top',
        end: '+=1000',
        scrub: 1.2
      }
    })

    gsap.to(heading, {
      scrollTrigger: {
        trigger: this.el,
        start: 'top top',
        end: '+=200',
        scrub: 1.2
      },
      color: 'transparent'
    })

    gsap.to(images, {
      scrollTrigger: {
        trigger: this.el,
        start: 'top top',
        end: '+=200',
        scrub: 1.2
      },
      opacity: 0.2
    })

    gsap.to(container, {
      y: 500,
      ease: 'none',
      scrollTrigger: {
        trigger: this.el,
        start: 'bottom bottom',
        end: 'bottom top',
        invalidateOnRefresh: true,
        scrub: 0
      }
    })

    spacer.classList.add('banner__text-spacer')
    video.after(spacer)
  }
  wordTicker() {
    const ticker = this.el.querySelector('.banner__ticker em')
    const words = ticker.querySelectorAll('.word')
    const animation = gsap.timeline({ repeat: -1 })

    words.forEach((word, i) => {
      animation.to(ticker, { duration: 0.75, y: `-${i}00%`, ease: 'power2.inOut' }, '+=2.5')
      animation.add(() => {
        this.changeImages(i)
      }, '<')
    })
  }
  changeImages(index) {
    const imageHolders = this.el.querySelectorAll('.banner__image-holder')

    imageHolders.forEach((imageHolder) => {
      const images = imageHolder.querySelectorAll('.banner__image')
      images.forEach((image) => image.classList.remove('active'))
      images[index].classList.add('active')
    })
  }
  scrollArrow() {
    const arrow = document.querySelector('.banner__arrow')

    arrow.addEventListener('click', () => {
      // smoother.scrollTo(1000, true, 0)
      lenis.scrollTo(1000, { duration: 1.2 })
    })
  }
  destroyAnimationBanner() {
    this.pinTl.kill()
  }
}

export const initAnimationBanner = () => {
  const banner = document.querySelector('.banner')
  if (banner) new AnimationBanner(banner)
}

export default () => {}
